import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		root: {
			flexDirection: 'column',
			display: 'flex',
			flexGrow: 1,
			width: '100%',
			maxWidth: '100%',
		},
		container: {
			position: 'absolute',
			top: theme.spacing(7.5),
			bottom: theme.spacing(6),
			width: '100%',
			height: 'auto',
			display: 'flex',
			flexDirection: 'column',
			alignSelf: 'center',
			flex: 1,
			[theme.breakpoints.up('sm')]: {
				minWidth: 670,
			},
		},
		loading: {
			color: 'rgba(255, 255, 255, 0.6)',
		},
		publishButton: {
			position: 'absolute',
			bottom: 0,
			right: 0,
			left: 0,
			width: '100%',
			height: theme.spacing(6),
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'center',
			color: '#ffffff',
			fontWeight: 700,
			fontSize: 18,
			backgroundColor: theme.palette.primary.main,
		},
		flexGrow: {
			flexGrow: 1,
		},
		error: {},
	})
